import { ArrowDownThin, Clear } from '@ori-ui/icons';
import { colors } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  popper: {
    '& .OriAutocompletePaper': {
      marginTop: 5,
      marginBottom: 5
    }
  },
  inputRoot: {
    '&[class*="MuiFilledInput-root"]': {
      paddingTop: 0,
      paddingLeft: 10,
      '& input': {
        padding: '14px 0'
      }
    },
    '&.Mui-focused': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: colors.oriGrey[400]
      }
    }
  },
  option: {
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '100%',
      width: '3px',
      opacity: 0,
      transitionDuration: '0.2s',
      transitionProperty: 'opacity',
      backgroundColor: colors.oriGrey[400],
      borderRadius: '0 2px 2px 0'
    },
    '&.Mui-focused.Mui-focused': {
      backgroundColor: `transparent`
    },
    '&[aria-selected="true"]': {
      '&::before': {
        opacity: 1
      }
    },
    '&:hover': {
      backgroundColor: `${colors.oriGrey[100]}`
    }
  }
};
const defaultProps = {
  clearIcon: _jsx(Clear, {
    fontSize: "small"
  }),
  popupIcon: _jsx(ArrowDownThin, {
    fontSize: "medium"
  }),
  classes: {
    paper: 'OriAutocompletePaper'
  }
};
export default {
  defaultProps,
  styleOverrides
};